import React from "react";
import "./Hero.scss";
import Navbar from "../navbar/Navbar";

const HeroSection = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 520;
    const isMedium = windowWidth >= 521 && windowWidth <= 768;
    
    let imgSrc;
    if (isMobile) {
        imgSrc = "/assets/images/new-hero-bg-small.png";
    } else if (isMedium) {
        imgSrc = "/assets/images/new-hero-bg-md.png";
    } else {
        imgSrc = "/assets/images/new-hero-bg-big.png";
    }

    const handleLogoClick = () => {
        const currentUrl = window.location.href;
        let redirectUrl = "https://atlasathlete.ai/";

        if (currentUrl.includes("uatathlete.mypainlog.ai")) {
            redirectUrl = "https://uat.atlasathlete.ai/";
        } else if (currentUrl.includes("devathlete.mypainlog.ai")) {
            redirectUrl = "https://dev.atlasathlete.ai/";
        } else if (currentUrl.includes("stgathlete.mypainlog.ai")) {
            redirectUrl = "https://stg.atlasathlete.ai/";
        } else if (currentUrl.includes("athlete.mypainlog.ai")) {
            redirectUrl = "https://atlasathlete.ai/";
        }

        window.location.href = redirectUrl;
    };

    return (
        <section
            className="hero-section"
            style={{
                backgroundImage: `url(${imgSrc})`,
                backgroundSize: isMobile ? "contain" : "cover",
                backgroundPosition: isMobile ? "center" : "top",
                backgroundRepeat: "no-repeat",
            }}
        >
            <Navbar />
            {/* Logo for large screens */}
            {/*<div className="hero-logo-container w-100-percent padding-12px">*/}
            {/*    <div className="logo-container"*/}
            {/*        onClick={handleLogoClick}*/}
            {/*    >*/}
            {/*        <img*/}
            {/*            src="/assets/images/logo1.png"*/}
            {/*            alt="Atlas Athlete AI"*/}
            {/*            className="hero-logo"*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/* Content section */}
            <div className="hero-content text-center text-white w-100-percent padding-top-16px">
                {/* Logo for small screens */}
                {/*<div className="hero-content-item-mobile-screen">*/}
                {/*    <div className="logo-container" onClick={handleLogoClick}>*/}
                {/*        <img*/}
                {/*            src="/assets/images/logo.png"*/}
                {/*            alt="Atlas Athlete AI"*/}
                {/*            className="hero-logo"*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/* Mobile text */}
                <div className="hero-content-text-container hero-mobile-text">
                    <div style={{ fontSize: "30px" }}>THE</div>
                    <div style={{ fontSize: "38px" }}>STARTING LINE</div>
                    <span style={{ fontSize: "36px", fontWeight: 300 }}>
                        FOR{" "}<span style={{ fontSize: "61px", fontWeight: 700 }}>
                            EVERY{" "}
                        </span>
                    </span>

                    <div style={{ fontSize: "61px", fontWeight: 700 }}>
                        ATHLETE
                    </div>
                </div>

                {/* Desktop text */}
                <div className="hero-content-text-container hero-desktop-text">
                    <div className="hero-content-text-1">
                        THE STARTING LINE FOR
                    </div>
                    <div className="hero-content-text-2">EVERY ATHLETE</div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
